<template>

  <!-- Overlay Start -->
  <div class="overlay"></div>
  <!-- Overlay End -->

  <!-- About Start -->
  <div class="section login-section-padding">

    <div class="section-padding-02 mt-n10">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">

            <!-- About Content Start -->
            <div class="about-content width-100">
              <h5 class="sub-title">Welcome to COLREGs.</h5>
              <h2 class="main-title">Master COLREGs and Ace Your <span>Maritime Certification</span>
              </h2>
              The COLREGs is your trusted online platform for COLREGs training and MSQ exam preparation. We help aspiring sailors, maritime professionals, and enthusiasts gain the knowledge and confidence needed for a successful sailing career.
              <br/><br/>
              <h5 class="sub-title">Our Mission:</h5> To provide structured, high-quality training and realistic practice tests that closely simulate real exam conditions—so you're fully prepared for certification.
              <br/><br/>
              <h5 class="sub-title">Why Choose The COLREGs?</h5>
              - Comprehensive COLREGs Question Bank developed by maritime experts to cover all essential rules and scenarios.
              <br/>
              - MSQ Exam Simulation with timed tests, randomized questions, and unlimited practice attempts for authentic preparation.
              <br/>
              - Flexible Learning Packages from quick trial tests to full-length final exams, tailored to your learning needs.
              <br/>
              - Progress Tracking to monitor your performance and identify areas for improvement.
              <br/><br/>
              <h5 class="sub-title">Learn Anytime, Anywhere:</h5> Our platform is mobile-friendly and accessible on any device, allowing you to study at your convenience—whether at home, onboard, or on the go.
              <br/><br/>
              <h5 class="sub-title">Who We Serve:</h5>
              - Aspiring Sailors: Build a strong foundation in COLREGs.
              <br/>
              - Maritime Professionals: Refresh and refine your knowledge for career advancement.
              <br/>
              - Organizations: Bulk training solutions for teams preparing for certification.
              <br/><br/>
              Join The COLREGs today and take the first step toward mastering COLREGs and achieving your maritime certification goals!
              <br/>
              <button @click="handleTryPracticeTest" class="btn btn-primary btn-hover-dark">Try Practice Test</button>
            </div>
            <!-- About Content End -->

          </div>
        </div>
      </div>
    </div>

    <div class="section-padding-02 mt-n6">
      <div class="container">

        <!-- About Items Wrapper Start -->
        <div class="about-items-wrapper">
          <div class="row">
            <div class="col-lg-4">
              <!-- About Item Start -->
              <div class="about-item">
                <div class="item-icon-title">
                  <div class="item-icon">
                    <i class="flaticon-tutor"></i>
                  </div>
                  <div class="item-title">
                    <h3 class="title">Expert Instructors</h3>
                  </div>
                </div>
                <p>Gain insights from experienced maritime professionals who craft real-world exam scenarios.
                  Prepare with confidence using expert-curated final tests and practice questions.</p>
              </div>
              <!-- About Item End -->
            </div>
            <div class="col-lg-4">
              <!-- About Item Start -->
              <div class="about-item">
                <div class="item-icon-title">
                  <div class="item-icon">
                    <i class="flaticon-coding"></i>
                  </div>
                  <div class="item-title">
                    <h3 class="title">Learn Anywhere</h3>
                  </div>
                </div>
                <p>Access COLREGs' online test platform from any device – no app required.
                  Practice and take final exams at your convenience, wherever you are.</p>
              </div>
              <!-- About Item End -->
            </div>
            <div class="col-lg-4">
              <!-- About Item Start -->
              <div class="about-item">
                <div class="item-icon-title">
                  <div class="item-icon">
                    <i class="flaticon-increase"></i>
                  </div>
                  <div class="item-title">
                    <h3 class="title">Fast Improvement</h3>
                  </div>
                </div>
                <p>Improve your maritime knowledge with structured practice and timed final exams.
                  Track your progress, review past tests, and refine your skills efficiently.</p>
              </div>
              <!-- About Item End -->
            </div>
          </div>
        </div>
        <!-- About Items Wrapper End -->

      </div>
    </div>

  </div>
  <!-- About End -->

  <!-- Login Required Modal -->
  <div v-if="showLoginModal" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="register-login-form login-box">
        <button class="modal-close" @click="closeModal">&times;</button>
        <h3 class="title">Login <span>Required</span></h3>
        <p class="modal-message">Please login to try the practice test</p>
        <div class="form-wrapper">
          <div class="single-form">
            <button 
              class="btn btn-primary btn-hover-dark w-100" 
              @click="goToLogin">
              Login Now
            </button>
          </div>
          <div class="single-form text-center mt-3">
            <p>Don't have an account? <router-link to="/register" class="text-primary">Register here</router-link></p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      showLoginModal: false
    };
  },
  methods: {
    handleTryPracticeTest() {
      const token = localStorage.getItem('access_token');
      
      if (token) {
        // User is logged in - redirect to dashboard manage-test page
        this.$router.push('/dashboard/user/manage-test');
      } else {
        // User not logged in - show login modal
        this.showLoginModal = true;
      }
    },

    goToLogin() {
      // Store the intended destination
      localStorage.setItem('redirect_after_login', '/dashboard/user/manage-test');
      this.$router.push('/login');
    },

    closeModal() {
      this.showLoginModal = false;
    }
  }
};
</script>

<style scoped>
/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal Content */
.modal-content {
  position: relative;
  background: #fff;
  padding: 40px;
  border-radius: 10px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Close Button */
.modal-close {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  font-size: 30px;
  line-height: 1;
  color: #999;
  cursor: pointer;
  transition: color 0.3s ease;
}

.modal-close:hover {
  color: #333;
}

/* Modal Message */
.modal-message {
  text-align: center;
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
}

/* Reuse existing login box styles */
.login-box .title {
  text-align: center;
  margin-bottom: 20px;
}

.login-box .single-form {
  margin-bottom: 15px;
}

/* Responsive */
@media (max-width: 768px) {
  .modal-content {
    padding: 30px 20px;
  }
}
</style>
